import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import cls from 'classnames';
import SessionElement from './SessionElem';
import SBSItem from './SBSItem';
import { formatDate, formatTime } from 'web-common/scripts/utils/DateHelper';
import FeatureToggleUtils from 'FeatureToggleUtils';

import {
    VIEW_MODE_SBS,
    VIEW_MODE_LIST,
    SESSIONS_TAB_ALL,
    SESSIONS_TAB_FAVOURITES,
    SESSIONS_TAB_REGISTRATIONS
} from 'constants/Enums';
import { UPDATE_LIVE_SESSIONS_INTERVAL } from './AgendaConstants';

const isClientSideRendered = typeof document !== 'undefined' && typeof window !== 'undefined';


class SessionList extends Component {
  static propTypes = {
      event: PropTypes.object.isRequired,
      me: PropTypes.object.isRequired,
      sessions: PropTypes.array.isRequired,
      settings: PropTypes.object.isRequired,
      speakers: PropTypes.object.isRequired,
      selectedDays: PropTypes.array.isRequired,
      agendaDays: PropTypes.array.isRequired,
      hasSessions: PropTypes.bool.isRequired,
      toggleMarker: PropTypes.func.isRequired,
      isSessionRegistrationEnabled: PropTypes.bool,
      showEmailLogin: PropTypes.func.isRequired,
      sessionClickHandler: PropTypes.func,
      siteConf: PropTypes.object.isRequired,
      shouldShowSessionPreviewWindow: PropTypes.bool.isRequired,
      shouldShowSessionDescriptionAgenda: PropTypes.bool,
      toggleSessionRegistrationStatusPerSession: PropTypes.func,
      openCloseTicketSelectionPopUp: PropTypes.func,
      ticketsSelectionData: PropTypes.object.isRequired,
      setSessionFullRegistration: PropTypes.func,
      showRegisterAndLoginModal: PropTypes.func,
      setVirtualSessionDetails: PropTypes.func,
      setScrollToSessionBroadcastAction: PropTypes.func,
      isRingAvailable: PropTypes.bool,
  };

  state = {
      currentDate: null
  };
  static defaultProps = {
      isSessionRegistrationEnabled: null
  };

    emptyStateMessage = (filter, date) => {
        const message = {};
        const sessionDate = date[0] ? formatDate(date[0], 'MMMM Do') : '';
        switch (filter){
        case SESSIONS_TAB_ALL:
            message.text = 'No sessions found.';
            break;
        case SESSIONS_TAB_REGISTRATIONS:
            if (sessionDate && date.length === 1){
                message.text = 'This is where you\'ll see all the sessions you\'re registered to on ';
                message.date = `${sessionDate}.`;
            } else {
                message.text = 'This is where you\'ll see all the sessions you\'re registered to.';
                message.date = '';
            }
            break;
        case SESSIONS_TAB_FAVOURITES:
            if (sessionDate && date.length === 1){
                message.text = 'This is where you\'ll see all the sessions you\'ll mark as interested on ';
                message.date = `${sessionDate}.`;
            } else {
                message.text = 'This is where you\'ll see all the sessions you\'ll mark as interested.';
                message.date = '';
            }
            break;
        }
        return message;
    };

    clearFilters = () => {
        const { clearAllTags, changeActiveTab } = this.props;
        clearAllTags();
        changeActiveTab(SESSIONS_TAB_ALL);
    };

    renderNoSessions = (hasSessions, activeTab, selectedDays) => {
        const imgName = hasSessions ? 'NoSessions2.png' : 'EmptyAgenda.png';
        const imgSrc = `/images/agenda/${imgName}`;
        const message = this.emptyStateMessage(activeTab, selectedDays);

        return (
            <Row className="no-sessions-container">
                <Col xs={12} className="no-sessions-text">
                    <span className="no-sessions-text-plain">{message.text && message.text}</span>
                    {message.date && (<span className="no-sessions-text-bold">{message.date}</span>)}
                </Col>
                <Col xs={12}>
                    <img className="no-sessions-image"
                        src={imgSrc}
                        alt=""
                    />
                </Col>
                <a className='btn full-agenda-btn color-1-background'
                    onClick={ this.clearFilters }>
                    View Full Agenda
                </a>
            </Row>
        );
    };

  getFormattedDate = (session) => {
      const datesFormatArray = this.props.settings.dateFormat.split(' ');
      return datesFormatArray.map((el, i) => <span
          className={cls('event-day-part$', {'week': el === 'ddd'})}
          key={i}>{`${formatDate(session.startDate, el)} `}
      </span>
      );
  };

  renderDateElement = (session) => {
      const { settings: { datesLabelType, datesLabelMapping }} = this.props;
      const isScheduled = session.startDate && session.startMinute >=0;
      const isDatesLabelsEnabled = datesLabelType === 'LABELS';
      const dateOrLabel = isDatesLabelsEnabled ? datesLabelMapping[`day-${session.startDate}`] : this.getFormattedDate(session);
      const notScheduledCopy = isDatesLabelsEnabled ? datesLabelMapping['not-scheduled'] : 'NOT SCHEDULED YET';
      return <Row className='day-title-row'>
          <Col lg={12}>
              <span className='day-title'>
                  {
                      isScheduled
                          ? dateOrLabel
                          : <span> {notScheduledCopy}</span>
                  }
              </span>
          </Col>
      </Row>;
  };

  renderSessionElement = (session, index) => {
      const {
          eventUrls,
          event,
          me,
          settings,
          speakers,
          clientNavigationAction,
          toggleMarker,
          isSessionRegistrationEnabled,
          showEmailLogin,
          sessionClickHandler,
          shouldShowSessionPreviewWindow,
          shouldShowSessionDescriptionAgenda,
          viewMode,
          toggleSessionRegistrationStatusPerSession,
          openCloseTicketSelectionPopUp,
          ticketsSelectionData,
          setSessionFullRegistration,
          shouldStickAgendaSearch,
          siteConf: {color1: color},
          siteConf,
          setVirtualSessionDetails,
          setScrollToSessionBroadcastAction,
          setRecordUrl,
          showRegisterAndLoginModal,
          setLoginV2OffsetTop,
          isRingAvailable,
      } = this.props;

      const isFeatureSessionVirtualElementEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');

      return <SessionElement
          key={session.id}
          {...{
              eventUrls,
              event,
              me,
              session,
              settings,
              speakers,
              isClientSideRendered,
              clientNavigationAction,
              toggleMarker,
              isSessionRegistrationEnabled,
              showEmailLogin,
              sessionClickHandler,
              shouldShowSessionPreviewWindow,
              shouldShowSessionDescriptionAgenda,
              SBSViewMode: viewMode === VIEW_MODE_SBS && !session.excluded,
              viewMode,
              toggleSessionRegistrationStatusPerSession,
              openCloseTicketSelectionPopUp,
              ticketsSelectionData,
              setSessionFullRegistration,
              index,
              shouldStickAgendaSearch,
              color,
              isFeatureSessionVirtualElementEnabled,
              setVirtualSessionDetails,
              setScrollToSessionBroadcastAction,
              setRecordUrl,
              showRegisterAndLoginModal,
              siteConf,
              setLoginV2OffsetTop,
              isRingAvailable,
          }}
      />;
  };

  renderItem = (session, i) => {
      const {
          settings,
          siteConf: {color1: color},
          sessionsMap: { listSessionsMap: sessionsMap}
      } = this.props;

      if (!sessionsMap) {
          return;
      }
      const sessionsByDay = sessionsMap[session.startDate];
      const sessionByTime = sessionsByDay && sessionsByDay[session.startMinute];
      const showTime = sessionByTime === session.id;
      const firstUnscheduledSession = sessionsMap.unscheduled === session.id;

      return <Col xs={12} key={session.id}>
          <div className="session-day-container">
              {((sessionsMap && sessionsMap[session.startDate] && sessionsMap[session.startDate].first === session.id) || firstUnscheduledSession) && this.renderDateElement(session) }
              <Row className="time-row">
                  {showTime && <Col md={1} xs={3} sm={2} className='time-elem'>
                      <div style={{backgroundColor: `var(--page-main-color, ${color})`}}>{formatTime(session.startMinute, settings.timeFormat)}</div>
                  </Col>}
                  <Col md={11} mdOffset={showTime ? 0 : 1} className="session-elem">
                      { this.renderSessionElement(session, i) }
                  </Col>
              </Row>
          </div>
      </Col>;
  }



  renderSessions = () => {
      const { viewMode, sessionsToRender, settings, siteConf, sessionsMap, sessions, getSliderSessions, activeTab,
          shouldStickAgendaSearch, setVirtualSessionDetails, setScrollToSessionBroadcastAction, setRecordUrl } = this.props;
      if (viewMode === VIEW_MODE_LIST) {
          return sessionsToRender.map(this.renderItem);
      }
      if (viewMode === VIEW_MODE_SBS ) {
          const isFeatureSessionVirtualElementEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');
          return sessionsToRender.map((session, index) => <SBSItem
              {...this.props}
              key={session.id}
              session={session}
              sessions={sessions}
              settings={settings}
              siteConf={siteConf}
              sessionsMap={sessionsMap.SBSSessionsMap}
              getSliderSessions={getSliderSessions}
              activeTab={activeTab}
              shouldStickAgendaSearch={shouldStickAgendaSearch}
              isFeatureSessionVirtualElementEnabled={isFeatureSessionVirtualElementEnabled}
              index={index}
              setVirtualSessionDetails={setVirtualSessionDetails}
              setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
              setRecordUrl={setRecordUrl}
          />);
      }
  };

  componentDidMount() {
      this.intervalId = setInterval(() => {
          this.setState({ currentDate: Date.now() });
      }, UPDATE_LIVE_SESSIONS_INTERVAL);
  }

  componentWillUnmount() {
      clearInterval(this.intervalId);
  }

  render() {
      const { sessionsToRender, hasSessions, isLoading, activeTab, selectedDays } = this.props;
      return <Row className="session-list-container">
          <Col xs={12} className="session-day">
              {this.renderSessions()}
              {isLoading
                  ? <div className='loading' />
                  : null
              }
              {!sessionsToRender.length && this.renderNoSessions(hasSessions, activeTab, selectedDays)}
          </Col>
      </Row>;
  }
}

export default SessionList;
